import { monotonicFactory } from 'ulid';

const ulid = monotonicFactory();
export const genULID = (): string => {
  return ulid();
};
